const $ = jQuery.noConflict();

class HomeHeroSliderPagination {
	constructor() {
		this.sliders = $('.block-home-hero__slider');
	}

	updatePaginationLeft() {
		for (let i = 0; i < this.sliders.length; i++) {
			const element = this.sliders[i];
			const pagination = element.querySelector('.slick-dots');

			if(pagination === null) {
				return;
			}

			const activePaginationItem = pagination.querySelector('li.slick-active');
			const activeLeft = activePaginationItem.offsetLeft;
			pagination.style.setProperty('--item-left', activeLeft + 'px');
		}
	}

	setMaxWidth() {
		for (let i = 0; i < this.sliders.length; i++) {
			const element = this.sliders[i];
			const pagination = element.querySelector('.slick-dots');

			if(pagination === null) {
				return;
			}

			const paginationEls = pagination.querySelectorAll('li');
			const itemMaxWidth = 100 / paginationEls.length;

			pagination.style.setProperty('--item-max-width', itemMaxWidth +'%');
			pagination.style.setProperty('--item-left', 0);
		}
	}

	addEvents() {
		this.sliders.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			const paginationEls = $(slick.$dots).find('li');
			const leftPos = $(paginationEls[nextSlide]).position().left;
			$(slick.$dots).css('--item-left', leftPos + 'px');
		});
	}

	init() {
		if(this.sliders.length > 0) {
			this.addEvents();
			this.setMaxWidth();
		}
	}
}

export default new HomeHeroSliderPagination();